import React from "react";
import {Link} from "react-router-dom";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {useEntrezMap} from "../../hooks/useEntrezMap";
import {verboseSymbols} from "../../utils/text";
import MessagePanel from "../MessagePanel";

const NoLibraryMessagePanel = React.memo(() => {
  const {selectedGenes} = useTheCellMapContext();
  const entrezMap = useEntrezMap();

  const selectedNoLibrary = selectedGenes.filter(g => !entrezMap?.[g.value]?.l);

  if (selectedNoLibrary.length === 0) return null;

  return <MessagePanel
    title="Data unavailable"
    symbols={verboseSymbols(selectedNoLibrary.map(option => option.symbol))}
    count={selectedNoLibrary.length}
    message="not present in the TKOv3 library and therefore do not appear on the network."
    extra={<>You can view interactions for
      {selectedNoLibrary.length > 1 ? " these genes " : " this gene "}
      in <Link to="/list">List View</Link> as
      {selectedNoLibrary.length > 1 ? " queries" : " query"}.
    </>}
  />
});

export default NoLibraryMessagePanel;